export const environment = {
  production: false, 
  apiUrl:'https://impactreportanalysis.impactexchange.com/API/api'
  //apiUrl: 'http://localhost:64770/api' 
  
};